export default __webpack_public_path__ + "static/media/blue-book.8141b12f.svg";